// extracted by mini-css-extract-plugin
export var body = "_3i-1";
export var bodyPadded = "_3i-2";
export var chevron = "_3i-4";
export var chevronOpen = "_3i-5";
export var header = "_3i-0";
export var icon = "_3i-3";